import { useState } from 'react';
import { AlertModal, Button, Para } from 'ui-components';

type Props = {
  onCancel: () => void;
};

export default function CancelButton({ onCancel }: Props): JSX.Element {
  const [open, setOpen] = useState<boolean>(false);

  const onConfirm = () => {
    onCancel();

    setOpen(false);
  };

  return (
    <>
      <Button fill="outlined" type="button" onClick={() => setOpen(true)}>
        Cancel
      </Button>

      <AlertModal
        open={open}
        onConfirm={onConfirm}
        onClose={() => setOpen(false)}
        title="Buchung Stornieren"
      >
        <Para size="2xl">Bist Du sicher, dass Du deine Buchung stornieren willst?</Para>
      </AlertModal>
    </>
  );
}
